import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AutomatedModal(_ref) {
  var setShowAutomated = _ref.setShowAutomated;
  return /*#__PURE__*/_jsx("div", {
    className: "absolute left-0 top-0 z-[1000] h-full w-full bg-[#00000075]",
    children: /*#__PURE__*/_jsxs("div", {
      className: "absolute bottom-0 left-0 flex h-[80%] w-full flex-col rounded-t-2xl bg-white p-6",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between gap-6",
        children: [/*#__PURE__*/_jsx("h4", {
          className: "mb-4 text-xl font-black",
          children: "Automated decision-making and your rights"
        }), /*#__PURE__*/_jsx("div", {
          role: "button",
          className: "justify-end",
          onClick: function onClick() {
            return setShowAutomated(false);
          },
          children: /*#__PURE__*/_jsx(CloseRoundedIcon, {})
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex h-0 flex-1 flex-col space-y-3 overflow-y-auto",
        children: [/*#__PURE__*/_jsx("p", {
          children: "Our platform uses automated decision-making. Article 22 of the General Data Protection Regulation grants you the right to not be subject to automated decision-making, including profiling, which has legal or other similarly significant effects on you."
        }), /*#__PURE__*/_jsxs("p", {
          children: ["If you would like to submit an objection please email", ' ', /*#__PURE__*/_jsx("a", {
            className: "text-brand-primary font-bold",
            href: "mailto:dpo@jove.co",
            children: "dpo@jove.co"
          }), "with your name, phone number, email address and details of the policy."]
        }), /*#__PURE__*/_jsx("p", {
          children: "To help us process your request quickly and efficiently, please provide as much detail about the automated decision-making that you are requesting we not perform. We will contact you for additional information if the scope of your request is unclear or does not provide sufficient information for us to conduct a search. We are permitted to continue using automated decision-making despite your objection. If we cannot honour your request, we will inform you of the reasons why, subject to any legal or regulatory restrictions."
        }), /*#__PURE__*/_jsx("p", {
          children: "If we determine that the data processing you are objecting to is not subject to Article 22, we will inform you of this decision."
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Please note, we may not be able to offer the same coverage by non-automated means."
          })
        })]
      })]
    })
  });
}